import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const routerMap = [
    {
        path: '/',
        redirect: '/index',
    },
    {
        path: '/index',
        component: () => import('@/views/index')
    },
    {
        path: '/generate',
        component: () => import('@/views/generate')
    },
]

export default new Router({
    routes: routerMap
})
